import axios from '@Utils/httpService';

const baseUrl = 'api/CustomDashboards';

export default {
    create(page) {
        return axios.post({
          url:baseUrl,
          data:page
        });
      },
      update(page) {
        return axios.put({
          url:baseUrl+`/${page.id}`,
          data:page
        });
      },
      
      del(id) {
        return axios.delete({url:baseUrl+`/${id}`} );
      },
      
      get(facilityId) {
        return axios.get({url:baseUrl+`/${facilityId}`});
      },

      /**
       * Transactional create-page-with-widgets (Dashboard Builder v1, spec §6 ship
       * criterion). STUB — the atomic backend endpoint does NOT exist yet, so this
       * rejects with a clear NOT-AVAILABLE error. Starter/Duplicate render disabled
       * until it ships; this guard is a safety net for the wired creation path.
       *
       * Expected contract (backend package §3): input = { operationId, name, icon,
       * facilityId, widgets: <buildWidgetPayload-shaped seeds> }; output carries an
       * operation/tab identity so a client-observed failure is reconcilable and Retry
       * re-runs the COMPLETE operation with no partial resume.
       *
       * @param {{ operationId: string, name: string, icon?: string, facilityId: string, widgets: object[] }} payload
       * @returns {Promise<never>}
       */
      createWithWidgets(payload) {
        void payload;
        return Promise.reject(new Error('DASHBOARD_CREATE_WITH_WIDGETS_NOT_AVAILABLE'));
      },
}